// @ts-nocheck
// TODO: tighten types after migration
import paymentService from './paymentService';

class BuyNowService {
    async buyNow(product, quantity, selectedVariants, userData = null) {
        try {
            // Create a simplified order data for direct purchase
            const orderData = {
                userId: (userData && userData.id) || null,
                email: (userData && userData.email) || 'guest@example.com', // Will be collected in payment form
                contactNumber: (userData && userData.contactNumber) || '',
                shippingAddress: {
                    name: (userData && userData.name) || '',
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'India'
                },
                billingAddress: {
                    name: (userData && userData.name) || '',
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'India'
                },
                products: [{
                    productId: product._id,
                    title: product.title,
                    productType: product.productType || 'physical',
                    variants: selectedVariants || {},
                    quantity: quantity,
                    price: product.offerPrice || product.price,
                    subtotal: (product.offerPrice || product.price) * quantity
                }],
                totalAmount: (product.offerPrice || product.price) * quantity,
                notes: `Direct purchase: ${product.title}`
            };

            // Initiate payment with Razorpay
            await paymentService.initiatePayment(orderData);
            
            return { success: true };
        } catch (error) {
            console.error('Error in buy now:', error);
            throw error;
        }
    }

    // Method to handle guest checkout with minimal data collection
    async guestBuyNow(product, quantity, selectedVariants) {
        try {
            // For guest checkout, we'll redirect to a simplified checkout page
            // or collect minimal information in the payment form
            
            const orderData = {
                userId: null,
                email: '', // Will be collected in payment form
                contactNumber: '',
                shippingAddress: {
                    name: '',
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'India'
                },
                billingAddress: {
                    name: '',
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'India'
                },
                products: [{
                    productId: product._id,
                    title: product.title,
                    productType: product.productType || 'physical',
                    variants: selectedVariants || {},
                    quantity: quantity,
                    price: product.offerPrice || product.price,
                    subtotal: (product.offerPrice || product.price) * quantity
                }],
                totalAmount: (product.offerPrice || product.price) * quantity,
                notes: `Guest purchase: ${product.title}`
            };

            // Store the order data temporarily for the checkout process
            sessionStorage.setItem('buyNowOrder', JSON.stringify(orderData));
            
            // Redirect to checkout page
            window.location.href = '/checkout?buyNow=true';
            
            return { success: true };
        } catch (error) {
            console.error('Error in guest buy now:', error);
            throw error;
        }
    }
}

const buyNowService = new BuyNowService();
export default buyNowService;

